export let ShareMixins = {
    methods: {
        shareOnFacebook: function() {
            window.open('https://www.facebook.com/sharer/sharer.php?u='+window.location.href, '_blank', 'width=600,height=600,scrollbars=no');
        },
        shareOnTwitter: function() {
            window.open('https://twitter.com/intent/tweet?url='+window.location.href, '_blank', 'width=600,height=600,scrollbars=no');
        },
        shareOnXing: function() {
            let url = encodeURIComponent(window.location.href);
            window.open('https://www.xing.com/spi/shares/new?url='+url, '_blank', 'width=600,height=600,scrollbars=no');
        },
        shareOnLinkedIn: function() {
            let url = encodeURIComponent(window.location.href);
            window.open('https://www.linkedin.com/sharing/share-offsite/?url='+url, '_blank', 'width=600,height=600,scrollbars=no');
        }
    }
}